import axios, { type InternalAxiosRequestConfig } from "axios";
import { apiLanguage } from "@/i18n";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost";

// Создаём два экземпляра axios
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Настройка axios по умолчанию для других запросов
axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

// Мова інтерфейсу на момент запиту: бекенд перекладає свої повідомлення
// (middleware SetLocaleFromAcceptLanguage), як і для клієнта з axios.ts.
// Без заголовка відповідь приходить мовою прода за замовчуванням.
function withApiLanguage(config: InternalAxiosRequestConfig) {
  config.headers["Accept-Language"] = apiLanguage();
  return config;
}
axios.interceptors.request.use(withApiLanguage);

// Перехватчик для обработки ошибок
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if this is a special OAuth authorization request
      if (error.response?.data?.requiresAuth) {
        return Promise.reject(error);
      }
      // Пользователь не авторизован
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

// Перехватчик для добавления токена
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return withApiLanguage(config);
});

// Перехватчик для api
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if this is a special OAuth authorization request
      // (requiresAuth flag means we need OAuth popup, not a full re-login)
      if (error.response?.data?.requiresAuth) {
        return Promise.reject(error);
      }
      localStorage.removeItem("auth_token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);
